<!-- Dealer: no online payment selected -->
@if (isDealer()) {
<div class="payment-item payment-item--dealer">
  <div class="payment-item__info">
    <img 
      class="payment-item__info__icon w-h-icon-24" 
      [src]="pendingIconPath" 
      [alt]="'payment-methods.status.dealer' | translate" />
    <div class="payment-item__info__text">
      <span class="payment-item__info__text__label">{{ statusKey() | translate }}</span>
    </div>
  </div>
</div>
}

<!-- Paid: approved / authorized / charged_back -->
@if (isPaid()) {
<div class="payment-item">
  <div class="payment-item__info">
    <img class="payment-item__info__icon" [src]="mpIconPath" alt="Mercado Pago" />
    <div class="payment-item__info__text">
      <span class="payment-item__info__text__label">
        {{ 'payment-methods.status.approved' | translate }}
        @if (payment().paymentId) { – {{ payment().paymentId }} }
      </span>
      @if (formattedDateTime()) {
      <span class="payment-item__info__text__date">{{ formattedDateTime() }}</span>
      }
    </div>
  </div>
  @if (showPrices()) {
  <div class="payment-item__total">
    <span>{{ totalLabel() | translate }}</span>
    <span>{{ payment().price | fdsCurrency }}</span>
  </div>
  }
</div>
}

<!-- Refunded -->
@if (isRefunded()) {
<div class="payment-item payment-item--refunded">
  <div class="payment-item__info">
    <img class="payment-item__info__icon" [src]="mpIconPath" alt="Mercado Pago" />
    <div class="payment-item__info__text">
      <span class="payment-item__info__text__label">
        {{ statusKey() | translate }}
        @if (payment().paymentId) { – {{ payment().paymentId }} }
      </span>
      @if (formattedDateTime()) {
      <span class="payment-item__info__text__date">{{ formattedDateTime() }}</span>
      }
    </div>
  </div>
  @if (showPrices()) {
  <div class="payment-item__total">
    <span>{{ totalLabel() | translate }}</span>
    <span>{{ payment().price | fdsCurrency }}</span>
  </div>
  }
</div>
}

<!-- Pending: pending / in_process / in_mediation / rejected / cancelled / error -->
@if (isPending()) {
<div class="payment-item payment-item--pending">
  <div class="payment-item__info">
    <img 
      class="payment-item__info__icon w-h-icon-24" 
      [src]="pendingIconPath" 
      [alt]="'payment-methods.status.pending' | translate" />
    <div class="payment-item__info__text">
      <span class="payment-item__info__text__label">
        {{ 'payment-methods.status.pending' | translate }}
        <button class="payment-item__info__text__label__info-btn" (click)="toggleModal()" type="button">
          <img src="../../../../../../../../../assets/lib/icons/info-icon-bg.svg" />
        </button>
      </span>
      @if (formattedDateTime()) {
      <span class="payment-item__info__text__date">{{ formattedDateTime() }}</span>
      }
    </div>
  </div>

  <app-ui-alert-information
    [alertType]="'warning'"
    [message]="'schedule.payment.alert.pending.normal' | translate"
    [iconType]="'normal'"
  />

  @if (showPrices()) {
  <div class="payment-item__total">
    <span>{{ totalLabel() | translate }}</span>
    <span>{{ payment().price | fdsCurrency }}</span>
  </div>
  }
</div>

<app-dialog [opened]="isModalOpen()" (openedChange)="toggleModal()" [modalCenter]="true">
  <p class="payment-item__modal__title">{{ 'schedule.payment.modal.title.normal' | translate }}</p>
  <p class="payment-item__modal__content">{{ 'schedule.payment.modal.content.normal' | translate }}</p>
  <div class="payment-item__modal__buttons">
    <lib-button type="primary" [rightIcon]="true"  (clickButton)="toggleModal()">
      {{ 'schedule.understood' | translate }}
    </lib-button>
  </div>
</app-dialog>
}
